import { render } from "./page6.vue?vue&type=template&id=ea85b62c&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"

import "./page6.vue?vue&type=style&index=0&id=ea85b62c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea85b62c"]])

export default __exports__